import React, { useContext } from "react"
import { Link } from "react-router-dom";
import moment from "moment";

import Card from "@material-ui/core/Card";
import { Tooltip } from "@material-ui/core";

import AuthContext from "../../../../context/auth-context";
import {
    translateFraudStatus,
    fraudStatusSiglum,
    fraudStatusColor,
} from "../../utils/utils";


function RegistrationDataValidationCard(props) {

    let user_data = useContext(AuthContext).user_data;

    let showLinkToNpAnalysis = !(
        props.registration_data_validation.analysis_status === "pending" ||
        props.registration_data_validation.analysis_status === "in_queue" ||
        props.registration_data_validation.analysis_status === "waiting_for_data" ||
        props.registration_data_validation.analysis_status === "failed"
    );

    let requestType = props.registration_data_validation.external_id

    return <Card className={["listCard", "collapse"].join(" ")}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            {
                showLinkToNpAnalysis
                    ? <Link
                        className={["listCardItem", "link", "subtitleSize", "bold"].join(
                            " "
                        )}
                        style={{ flex: "2 1 120px", textAlign: "center" }}
                        to={"/registration-data-validation/" + props.registration_data_validation.event_key}
                    >
                        {requestType}
                    </Link>
                    : <div
                        className={["listCardItem", "subtitleSize", "bold"].join(" ")}
                        style={{ flex: "2 1 120px", textAlign: "center" }}
                    >
                        {requestType}
                    </div>
            }
            {
                user_data.business_group_key ? (
                    props.registration_data_validation.company_name ? (
                        <div
                            className={["listCardItem", "normalText", "subtitleSize"].join(
                                " "
                            )}
                            style={{ flex: "2 1 200px", textAlign: "center" }}
                        >
                            {props.registration_data_validation.company_name}
                        </div>
                    ) : null
                ) : null
            }
            <div
                className={[
                    "listCardItem",
                    "normalText",
                    "subtitleSize",
                    "noWrap",
                ].join(" ")}
                style={{ flex: "1 1 145px", textAlign: "center" }}
            >
                {props.registration_data_validation.event_data.document_number}
            </div>
            <div
                className={[
                    "listCardItem",
                    "normalText",
                    "normalMediumSize",
                    "bold",
                ].join(" ")}
                style={{ flex: "1 1 45px", textAlign: "center", cursor: "default" }}
            >
                <Tooltip
                    title={
                        <p className="tooltipText">
                            {translateFraudStatus(props.registration_data_validation.analysis_status)}
                        </p>
                    }
                >
                    <div
                        className={["circle", "small"].join(" ")}
                        style={{
                            backgroundColor: fraudStatusColor(
                                props.registration_data_validation.analysis_status
                            ),
                        }}
                    >
                        {fraudStatusSiglum(props.registration_data_validation.analysis_status)}
                    </div>
                </Tooltip>
            </div>
            <div
                className={[
                    "listCardItem",
                    "normalText",
                    "subtitleSize",
                    "noWrap",
                ].join(" ")}
                style={{ flex: "1 1 110px", textAlign: "center" }}
            >
                {moment(props.registration_data_validation.created_at).format(
                    "DD/MM/YYYY HH:mm:ss"
                )}
            </div>
        </div>
    </Card>
}

export default RegistrationDataValidationCard;